import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalCadastroComponent } from '../../../../shared/modal-cadastro/modal-cadastro.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageService } from '@services';

@Component({
  selector: 'app-relatorio-contas-pagar',
  templateUrl: './relatorio-contas-pagar.component.html',
  styleUrls: ['./relatorio-contas-pagar.component.css'],
})
export class RelatorioContasPagarComponent extends ModalCadastroComponent implements OnInit {
  constructor(private message: MessageService) {
    super();
  }

  @ViewChild('modalRelatorio', { static: true }) modalRelatorio;
  selecionados: [] = [];
  form: FormGroup;

  tiposRelatorio = [
    { id: 0, label: 'Contas Contraídas' },
    { id: 1, label: 'Contas por Fornecedor' },
    { id: 2, label: 'Contas por Vencimento' },
    { id: 3, label: 'Contas Pagas' },
    { id: 4, label: 'Contas por Grupo de Despesa' },
    { id: 5, label: 'Contas por Centro de Custo' },
  ];

  ngOnInit() {
    this.form = new FormGroup({
      tipoRelatorio: new FormControl(0, [Validators.required]),
      modoDetalhado: new FormControl(false),
      orientacao: new FormControl(false),
      formato: new FormControl(false),
      somenteDocumentosSelecionados: new FormControl(false),
    });

    this.selecionados = this.prop;
  }

  show(): void {
    this.modalRelatorio.show();
  }

  close() {
    this.closed.emit(null);
  }

  imprimir() {
    if (this.form.invalid) {
      return;
    }
    this.closed.emit(this.form.value);
  }

  checkSelecionados() {
    if (this.selecionados.length > 0) {
      return;
    }

    this.form.controls['somenteDocumentosSelecionados'].setValue(false);
    this.message.warning('Nenhum documento selecionado na consulta.', 8000, 'Aviso!');
  }
}
